<template>
	<el-dialog v-model="innerVisible" title="新建单据" width="92%"  custom-class="zero-padding-modal" 
	@open="openInit" @opened="openedInit" @closed="closeDeal">
		<template #default>
			<div class="assemble-edit-modal-content">					
				<div class="" style="margin: 30px 60px 10px 60px;">
					<el-form layout="inline" :model="query" ref="dialogRef" :rules="formRules">
						<el-row :gutter="48">
							<el-col :md="widthmd" :sm="24">
							<el-form-item label="进货单别"  prop="restockType">
								<el-select v-model="query.restockType" placeholder="请选择进货单别" style="width: 100%;">
									<el-option v-for="item in selectOptions.testockTypeData" :key="item.mQ001" :label="item.mQ002" :value="item.mQ001" />
								</el-select>
							</el-form-item>
							</el-col> 
							<el-col :md="widthmd" :sm="24">
							<el-form-item label="单据日期">
								<el-date-picker v-model="query.restockOrderDate" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择单据日期" style="width: 100%" />
							</el-form-item>
							</el-col>
							<el-col :md="4" :sm="24">
							<el-form-item label="进货日期">
								<el-date-picker v-model="query.restockDate" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择进货日期" style="width: 100%" />
							</el-form-item>
							</el-col>

							<el-col :md="3" :sm="24">
							<el-form-item label="供应商编号">
								<el-input v-model="query.supplierInfoCode" allow-clear placeholder="请输入供应商编号" disabled/>
							</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="48">
							<el-col :md="widthmd" :sm="24">
								<el-form-item label="部门编号"  prop="department">									
									<el-select v-model="query.department" placeholder="请选择部门" style="width: 100%;">
									<el-option v-for="item in selectOptions.departmentData" :key="item.mE001" :label="item.mE002" :value="item.mE001" />
								</el-select>
								</el-form-item>
							</el-col>
							<el-col :md="2" :sm="24">
							<el-form-item label="税种">
								<el-input v-model="query.taxCategories" allow-clear placeholder="请输入税种"/>
							</el-form-item>
							</el-col>			
							
							<el-col :md="widthmd" :sm="24">
							<el-form-item label="项目编号">
								<el-input v-model="query.projectCode" allow-clear placeholder="请输入项目编号" disabled/>
							</el-form-item>
							</el-col>
							<el-col :md="widthmd" :sm="24">
							<el-form-item label="采购单号"  prop="purchaseNo">
								<el-input v-model="query.purchaseNo" allow-clear placeholder="请输入采购单号" disabled/>
							</el-form-item>
							</el-col>         
						</el-row>
						<el-row :gutter="48">
							<el-col :md="3" :sm="24">
							<el-form-item label="币种">
								<el-input v-model="query.currency" allow-clear placeholder="请输入币种"/>
							</el-form-item>
							</el-col>
							<el-col :md="2" :sm="24">
							<el-form-item label="汇率">
								<el-input v-model="query.exchangeRate" allow-clear placeholder="请输入汇率"/>
							</el-form-item>
							</el-col> 
							<el-col :md="3" :sm="24">
							<el-form-item label="增值税率">
								<el-input v-model="query.vatRate" allow-clear placeholder="请输入增值税率"/>
							</el-form-item>
							</el-col>
							<el-col :md="3" :sm="24">
							<el-form-item label="工厂">
								<el-input v-model="query.factory" allow-clear placeholder="请输入工厂" disabled/>
							</el-form-item>
							</el-col>
							
						</el-row>
					</el-form>
				</div> 					
				<div class="list-padding" style="margin: 0px 20px 10px 20px;">					
					<el-table :data="list" border row-key="tableKey" highlight-current-row height="400px">
						<el-table-column label="序号" align="center" width="50">
							<template #default="scope">{{scope.$index+1}}</template>
						</el-table-column>
						<el-table-column prop="materialCode" label="物料编号" align="center" show-overflow-tooltip="" />
						<el-table-column prop="warehouse" label="仓库" align="center" show-overflow-tooltip="" />
						<el-table-column prop="purchaseType" label="采购单别" align="center" show-overflow-tooltip="" />
						<el-table-column prop="purchaseNo" label="采购单号" align="center" show-overflow-tooltip="" />
						<el-table-column prop="purchaseQuantity" label="采购数量" align="center" show-overflow-tooltip="" />
						<el-table-column prop="quantityUsed" label="已进货数量" align="center" show-overflow-tooltip="" />
						<el-table-column prop="restockQuantity" label="进货数量" align="center" show-overflow-tooltip="" />
						<el-table-column prop="acceptanceQuantity" label="验收数量" align="center" show-overflow-tooltip="" />
						<el-table-column prop="returnQuantity" label="验退数量" align="center" show-overflow-tooltip="" />
						<el-table-column prop="locationCode" label="库位" align="center" show-overflow-tooltip="" />
						<el-table-column prop="projectCode" label="项目编号" align="center" show-overflow-tooltip="" />
						<!-- <el-table-column prop="batchNo" label="批号" align="center" show-overflow-tooltip="" />
						<el-table-column prop="acceptanceDate" label="验收日期" align="center" show-overflow-tooltip="" /> -->
						<!-- <el-table-column prop="productionDate"  label="生产日期" align="center" show-overflow-tooltip="" />
						<el-table-column prop="scrapQuantity" label="报废数量" align="center" show-overflow-tooltip="" />
						<el-table-column prop="destructionQuantity" label="破坏数量" align="center" show-overflow-tooltip="" />
						<el-table-column prop="articleNumber" label="主件品号" align="center" show-overflow-tooltip="" />
						<el-table-column prop="unit" label="单位" align="center" show-overflow-tooltip="" />
						<el-table-column prop="purchaserUserName" label="采购人员" align="center" show-overflow-tooltip="" />
						<el-table-column prop="parameter" label="参数" align="center" show-overflow-tooltip="" />
						<el-table-column prop="giftQuantity" label="赠备品验收数量" align="center" show-overflow-tooltip="" />
						<el-table-column prop="conversionRate" label="折算率" align="center" show-overflow-tooltip="" />
						<el-table-column prop="auditor" label="审核者" align="center" show-overflow-tooltip="" />
						<el-table-column prop="expirationDate" label="有效日期" align="center" show-overflow-tooltip="" />
						<el-table-column prop="recheckDate" label="复检日期" align="center" show-overflow-tooltip="" />
						<el-table-column prop="amount" label="原币扣款金额" align="center" show-overflow-tooltip="" />
						<el-table-column prop="deductMoneyRemark" label="扣款说明" align="center" show-overflow-tooltip="" />
						<el-table-column prop="batchNoRemark" label="批号说明" align="center" show-overflow-tooltip="" />
						<el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip="" /> -->
						
						<el-table-column label="操作" width="" align="center">
							<template #default="scope">
								<el-button type="" size="small" @click="onEdit(scope.row,scope.$index)"  :disabled="scope.row.restockQuantity <= 0">编辑</el-button>
								<!-- <el-button type="danger" size="small" @click="onDel(scope.$index)">删除</el-button>						 -->
							</template>
						</el-table-column>
					</el-table>
				</div>				
			</div>			
			<edit-modal v-model:visible="chooseVisieble" :editInfo="editInfo" @callback="chooseModalCallback"  />
		</template>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="onBtnClose">取 消</el-button>
				<el-button type="primary" @click="onComfirm">提 交</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { defineEmits, reactive, ref, watch, toRefs } from 'vue'	
import EditModal from './editModal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { testockType ,department,location,page ,RestockOrderAdd,RestockOrderDelete} from '@/service/main/invoices/buildGoods'
//import { localStatus } from '../../switchCase'
//rules
const formRules = {
	department: [{ required: true, message: '部门编号不能为空', trigger: 'blur' }],
    restockType: [{ required: true, message: '进货单别不能为空', trigger: 'blur' }],
    purchaseType: [{ required: true, message: '采购单别不能为空', trigger: 'blur' }],
    purchaseNo: [{ required: true, message: '采购单号不能为空', trigger: 'blur' }],
}
const emits = defineEmits(['update:visible','loadInitData','callback'])
const widthmd = ref(4)
const props = defineProps({
	visible:{
		type:Boolean,
		default:false
	},
	info:{
		type:Object,
		default:()=>{
			return {}
		}
	}
})
const { visible, info } = toRefs(props)

const innerVisible = ref(false)

const chooseVisieble = ref(false)
const list = ref([])
const query = ref({})
const selectOptions = reactive({
	testockTypeData:[],
	departmentData:[]
})

watch(
	visible,
	function(newVal){
		if (innerVisible.value!==newVal) {
			innerVisible.value = newVal
		}
	},
	{immediate:true}
)
watch(innerVisible,function(newVal){
	if (visible.value!==newVal) {
		emits('update:visible',newVal)
	}
})

const closeDeal = function(){
	selfClose()
}

const onBtnClose = function(){
	selfClose()
}

const selfClose = function(){
	list.value = []
	infoList.value = []
	query.value = {}
	innerVisible.value = false
}

const dialogRef = ref()
const onComfirm = function(){
	dialogRef.value.validate((valid) => {
        if (valid) {
			console.log('valid',valid)
			confirm((f)=>{
				if (f) {
					ElMessage.success("操作成功")
					selfClose()
					emits('callback')
				}
			})

        }
      })
	// let f = checkBeforeSubmit()
	// if (!f) return flase
	
}

const openedInit = function(){
	getModifyInitData()
	gettestockType()
	getdepartment()
}

const getModifyInitData = function(){
	let para = {
			TC001:info.value.purchaseType,
			TC002:info.value.purchaseNo
		}	
	emits('loadInitData',para,function(f,d){
		if (f) {
			query.value = d.data
			console.log('query.value',query.value)
			list.value = (d.data.restockOrderDetails || []).map((obj,index)=>{
				obj.tableKey = 'edit-' + new Date().getTime() + '-' + index
				return obj
			})
		}
	})
}
const gettestockType = function(){
	if (selectOptions.testockTypeData.length<=0) {
		testockType().then((res) => {
			let arr = res.data || []
		  	selectOptions.testockTypeData = arr
		})
	} 
}
const getdepartment = function(){
	if (selectOptions.departmentData.length<=0) {
		department().then((res) => {
			let arr = res.data || []
		  	selectOptions.departmentData = arr
		})
	} 
}
const editInfo = ref({})
const indexInfo = ref(0)
const onEdit = function(row,index){
	indexInfo.value = index
	editInfo.value = row
	chooseVisieble.value = true
}
const infoList = ref([])
const chooseModalCallback = function(obj){
	list.value[indexInfo.value] = obj
	infoList.value.push(obj)
}

const onDel = function(index) {
	list.value.splice(index,1)
}

const confirm= function(callback){
	query.value.restockOrderDetails = infoList
	//console.log('query',query.value)
	RestockOrderAdd(query.value).then((res) => {
	callback && callback(true)
	}).catch(()=>{
		callback && callback(false)
	})
}

</script>

<style lang="less" scoped>
.assemble-edit-modal-content{
	height: 75vh;
	display: flex;
	flex-direction: column;
	.modal-content-top {
		padding: 12px 16px;
		flex-shrink: 0;
	}
	.modal-content-list{
		flex-grow: 1;
		height: 1px;
		overflow: auto;
		.list-padding{
			padding: 0 16px;
		}
	}
}
</style>